import { render } from "./AppPasswordReset.vue?vue&type=template&id=08202886&scoped=true"
import script from "./AppPasswordReset.vue?vue&type=script&lang=js"
export * from "./AppPasswordReset.vue?vue&type=script&lang=js"

import "./AppPasswordReset.vue?vue&type=style&index=0&id=08202886&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08202886"]])

export default __exports__